// extracted by mini-css-extract-plugin
export default {"col":"OuMange_col__9bsnZ","wrapperPadding":"OuMange_wrapperPadding__xnNT1"};